import { render, staticRenderFns } from "./koejakso-view-virkailija.vue?vue&type=template&id=1c01eb68&scoped=true&"
import script from "./koejakso-view-virkailija.vue?vue&type=script&lang=ts&"
export * from "./koejakso-view-virkailija.vue?vue&type=script&lang=ts&"
import style0 from "./koejakso-view-virkailija.vue?vue&type=style&index=0&id=1c01eb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01eb68",
  null
  
)

export default component.exports